module.exports = __webpack_public_path__ + "img/insta.5d080ad7.svg";